import React from 'react'
import { storiesOf } from '@storybook/react'

import UserInfo from 'components/UserInfo'
import Paper from 'components/Paper'

storiesOf('UserInfo', module)
  .add('default', () => (
    <UserInfo />
  ))
  .add('with values', () => (
    <UserInfo
      playedGames={67}
      avatarUrl="http://tny.im/f67"
      winnings={[{ value: 23865 }]}
      username={'John Smith'}
      wins={172}
    />
  ))
  .add('in accent paper', () => (
    <Paper color="accent">
      <UserInfo
        playedGames={67}
        avatarUrl="http://tny.im/f67"
        winnings={[{ value: 23865 }]}
        username={'John Smith'}
        wins={172}
      />
    </Paper>
  ))
